<app-auth-navbar></app-auth-navbar>
<div class="cxy-page-header">
    <div class="cxy-page-container w-container">
        <div class="cxy-header-left kenya-header-left">
            <div>
                <div class="text-block-25"><span class="text-span-3">USD</span> to <span class="text-span-4">NGN</span></div>
            </div>
            <div>
                <h2 class="heading-10"><strong>Send money to Nigeria fast</strong></h2>
            </div>
            <div>
                <div class="text-block-26">Send money “faster and cheaper” to your nephew in Lagos or your friend in Onitsha. There are 100 reasons to send money from The United States to Nigeria instantly with N2Xpress.<br></div>
            </div>
        </div>
        <div class="cxy-header-right">
            <div class="calculator-panel marginTop">
                <div class="calculator-header">
                    <!-- <h1 class="hero-heading">Save more with <br>online money transfers</h1> -->
                    <h1 class="hero-heading custom-heroHeading">Send money from The United States to Nigeria</h1>
                </div>
                <div class="form-block w-form">
                  <form id="email-form" name="email-form" data-name="Email Form" redirect="https://app.n2xpress.ca/login" data-redirect="https://app.n2xpress.ca/login" class="form">
                      <div class="div-block-13">
                          <input [(ngModel)]="amount" (keyup)="onAmountChange($event.target.value)" type="number" style="background:none!important; border:none;" class="text-field w-input m-0 p-3" def="10" autofocus="true" maxlength="256" name="Send" data-name="Send" placeholder="You send" id="currency-send" required="">
                          <div data-hover="" data-delay="0" class="w-dropdown">
                              <div class="dropdown  color-blue radiusr-5" style="height:50px" (click)="common.showDropdown('sourceDrop')" id="sourceDrop"> 
                                  <button class="p-0 px-2 bg-transparent h-100 d-flex justify-content-center align-items-center dropdown-button "> 
                                      <!-- Country -->
                                      {{ countryName }}  <img [src]="'assets/images/' + source + '.png'" class="ml-1" width="22" height="22">
                                      <!-- <span class="fas fa-angle-down pl-2"></span> -->
                                  </button> 
                                  
                                  <!-- <div class="dropdown-content"> 
                                      <a (click)="onSourceChange('cad','Canada')" class="d-flex justify-content-between align-items-center"> 
                                          Canada
                                          <img alt="CAD" src="assets/images/cad.png" class="ml-1" width="20" height="20">
                                      </a> 
                                      
                                      <a (click)="onSourceChange('usd','USA')" class="d-flex justify-content-between align-items-center"> 
                                          USA
                                          <img alt="USA" src= "assets/images/usd.png" class="ml-1" width="20" height="20"> 
                                      </a> 
                                      
                                  </div>  -->
                              </div>
                              
                          </div>
                      </div>
                      <div class="rate-panel">
                          <div class="div-block-15"></div>
                          <div class="div-block-16">
                              <div class="div-block-17">
                                  <div>
                                      <div id="currency-fees" class="fee-figure">{{transactionFees}}</div>
                                  </div>
                                  <div class="rate-currency">
                                      <div id="fees-currency" class="rate-currency-text">{{source.toUpperCase()}}</div>
                                  </div>
                                  <div class="fee-explainer-text">
                                      <div class="explainer-text pl-3">Total fees</div>
                                  </div>
                              </div>
                              <div class="div-block-18">
                                  <div class="rate-figure">
                                      <div id="currency-rate" class="text-block-12">{{conversionRate}}</div>
                                  </div>
                                  <div class="rate-currency">
                                      <div id="exchange-currency" class="rate-currency-text">{{destination_currency.toUpperCase()}}</div>
                                  </div>
                                  <div class="rate-explainer">
                                      <div class="explainer-text">Your exchange rate</div>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <div class="div-block-13-copy">
                          <input [(ngModel)]="convertedAmount" readonly type="number"  style="background:none!important; border:none;" class="text-field w-input m-0 p-3" maxlength="256" name="Receive" data-name="Receive" placeholder="They receive" id="currency-receive">
                          <div data-hover="" data-delay="0" class="w-dropdown">
                              <div class="dropdown color-blue radiusr-5" style="height:50px" (click)="common.showDropdown('destDrop')" id="destDrop"> 
                                  <button class="p-0 px-2 bg-transparent h-100 d-flex justify-content-center align-items-center dropdown-button "> 
                                      <!-- Country -->
                                      {{ destinationCountryName }} <img [src]="'assets/images/' + destination_currency + '.png'"  class="ml-1" width="22" height="22">
                                      <span class="fas fa-angle-down pl-2"></span>
                                  </button> 
                                  
                                  <div class="dropdown-content"> 
                                      <a  (click)="onDestinationChange('ghs','Ghana', 83)" class="d-flex justify-content-between align-items-center"> 
                                          Ghana
                                          <img  alt="GHS" src="assets/images/ghs.png" (click)="onDestinationChange('ghs','Ghana', 83)" class="ml-1" width="20" height="20">
                                      </a> 
                                      <a (click)="onDestinationChange('ngn','Nigeria', 161)" class="d-flex justify-content-between align-items-center"> 
                                          Nigeria
                                          <img alt="NGN" src="assets/images/ngn.png" class="ml-1" width="20" height="20">
                                      </a> 
                                      <a (click)="onDestinationChange('inr','India', 101)" class="d-flex justify-content-between align-items-center" > 
                                          India
                                          <img alt="INR" src="assets/images/inr.png" class="ml-1" width="20" height="20">
                                      </a> 
                                      <a (click)="onDestinationChange('kes','Kenya', 113)"  class="d-flex justify-content-between align-items-center"> 
                                          Kenya
                                          <img alt="KES" src="assets/images/kes.png" class="ml-1" width="20" height="20">
                                      </a> 
                                      <a  *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('xof','Benin', 24)"> 
                                        Benin
                                        <img alt="BENIN" src="assets/images/benin.png" class="ml-1" width="20" height="20">
                                      </a> 
                                      <a  *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('xof','Senegal', 195)"> 
                                        Senegal
                                        <img alt="XOF" src="assets/images/xof.png" class="ml-1" width="20" height="20">
                                      </a> 
                                      <a  *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('zar','South Africa', 204)"> 
                                        South Africa
                                        <img alt="ZAR" src="assets/images/zar.png" class="ml-1" width="20" height="20">
                                      </a> 
                                      <a  *ngIf="source!='usd'" class="d-flex justify-content-between align-items-center" (click)="onDestinationChange('php','Philippines', 174)"> 
                                        Philippines
                                        <img alt="PHP" src="assets/images/php.png" class="ml-1" width="20" height="20">
                                      </a> 
                                  </div> 
                              </div>
                              
                          </div>
                      </div>
                  </form>
                  <div class="w-form-done">
                      <div>Thank you! Your submission has been received!</div>
                  </div>
                  <div class="w-form-fail">
                      <div>Oops! Something went wrong while submitting the form.</div>
                  </div>
              </div>
                <a  id="send-money-button" style="background:#266DD3;" routerLink="/dashboard" class="calculator-button w-button w-button-sm14">Send money across borders, the easy way<span><img class="ml-2" width="18px" src="assets/images/send-logo.PNG" alt=""></span></a>
            </div>
        </div>
    </div>
</div>
<div class="benefits-heading-section">
    <div class="w-container">
      <div class="testimonial-header"><img src="assets/images/Logo-pink.svg" loading="lazy" alt="n2xpress - Send money across borders, the easy way." class="benefits-chop">
        <div class="benefits-heading"><strong>Benefits of sending money from The United States to Nigeria through N2Xpress</strong></div>
      </div>
    </div>
  </div>
  <div class="benefits-section">
    <div class="w-container">
      <div class="benefits-body">
        <div class="cxy-benefit-box">
          <div class="cxy-benefit-header">
            <div class="pink">Send money to any bank in Nigeria</div>
          </div>
          <div class="benefit-body">
            <div class="benefit-body-text">Transfer money directly to any bank account in Nigeria. You can transfer money to Nigeria for family needs, investments, EMIs, loan payments and property purchases, with best exchange rates and zero fees. Save more and do more.</div>
          </div>
        </div>
        <div class="cxy-benefit-box">
          <div class="cxy-benefit-header">
            <div class="yellow">Multiple sending options<br></div>
          </div>
          <div class="benefit-body">
            <div class="benefit-body-text">Sending money through multiple options is an advantage in itself. Just imagine you have several options to choose from and you never fail to meet the deadline. Switch to N2Xpress and use money sending and receiving options and never miss pleasing your loved ones. Get the best exchange rate and on time transfers at your fingertips.</div>
          </div>
        </div>
        <div class="cxy-benefit-box">
          <div class="cxy-benefit-header">
            <div class="purple">The lowest transfer fees</div>
          </div>
          <div class="benefit-body">
            <div class="benefit-body-text">When it comes to money transfers, everyone expects to transfer at affordable rates. N2Xpress has revolutionised the money transfer industry with its unique features - you always get the best rates available.</div>
          </div>
        </div>
        <div class="cxy-benefit-box">
          <div class="cxy-benefit-header">
            <div class="green">Transfer money instantly</div>
          </div>
          <div class="benefit-body">
            <div class="benefit-body-text">Sign up, verify your account, and get ready for transacting. All it takes is just a few taps. The money is sent instantly overseas, transferred to the recipient.</div>
          </div>
        </div>
        <div class="cxy-benefit-box">
          <div class="cxy-benefit-header">
            <div class="purple">Competitive exchange rates</div>
          </div>
          <div class="benefit-body">
            <div class="benefit-body-text">Our exchange rate calculator carefully compares rates and fees and gives you great exchange rates. We add significant value to your transfer and keep your loved ones happy.</div>
          </div>
        </div>
        <div class="cxy-benefit-box">
          <div class="cxy-benefit-header">
            <div class="green">24/7 customer support </div>
          </div>
          <div class="benefit-body">
            <div class="benefit-body-text">Don&#x27;t lose sight of your money. Our customer care executives are available 24/7 to help you out. Email us and you will receive a response the same day.</div>
          </div>
        </div>
        <div class="cxy-benefit-box">
          <div class="cxy-benefit-header">
            <div class="yellow">Secure and safe</div>
          </div>
          <div class="benefit-body">
            <div class="benefit-body-text">You can trust us with your hard earned money while sending money to Nigeria. We offer bank-grade security without the slow pace and high fees. Using the highest security and compliance processes, your money and personal details are safe with us. We ensure safe delivery of your money. </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="testimonial-section">
    <div class="instruction-container w-container">
      <div class="instruction-header"><img src="assets/images/Testimonial-Chop.svg" loading="lazy" alt="n2xpress - Send money across borders, the easy way." class="image-2">
        <div class="section-header-text instructions">Steps to send money to Nigeria online</div>
      </div>
      <div class="upper-instructions">
        <div class="instruction-card _1">
          <div class="instruction-heading _1">1. Create your free account</div>
          <div class="instrucrtion-body">Register online and enter your personal details for ID verification. Make sure what you enter matches exactly with your identification documents.</div>
        </div>
        <div class="instruction-card _2">
          <div class="instruction-heading _2">2. Choose method</div>
          <div class="instrucrtion-body">Select the currency, country, person and amount. We’ll show you the exchange rate and total fees upfront for hassle free transfer to the recipient&#x27;s account.</div>
        </div>
      </div>
      <div class="lower-instructions">
        <div class="instruction-card _3">
          <div class="instruction-heading _3">3. Input receiver details </div>
          <div class="instrucrtion-body">Tell us the details of the person receiving the money. Make sure it matches their identification documents exactly. Don&#x27;t worry about all the information you enter as we keep every detail confidential.</div>
        </div>
        <div class="instruction-card _4">
          <div class="instruction-heading _4">4. Confirm and send</div>
          <div class="instrucrtion-body">Double check everything is correct and send your money to Nigeria. That’s it. We’ll take care of the rest and tell you when it has arrived. Through email or text we will notify you.</div>
        </div>
      </div>
      <div class="call-to-action-button">
        <a id="sign-up-button-on-page" routerLink="/register" class="button-3 w-button">Sign up</a>
      </div>
    </div>
  </div>
  <div class="cad-to-inr-header-container">
    <h1 class="cad-to-inr-heading"><strong>How to send from The United States to Nigeria at lower transfer fees?</strong></h1>
  </div>
  <div class="batching-section">
    <div class="batching-container w-container">
      <div class="cxy-right">
        <div class="cad-to-inr-description-container">
          <div class="cad-to-inr-description">We compare and give you the best money transfer rates from The United States to Nigeria. <br>‍<br>To transfer your United States dollars to a bank account in Nigerian Naira (NGN) in Nigeria, the cheapest provider at the moment is N2Xpress with transfer fees at just 1% and a very competitive USD-NGN conversion rate. Send money to Nigeria the smart way.<br></div>
        </div>
      </div>
    </div>
  </div>
  <div class="n2xpress-help-heading instruction-header"><img src="assets/images/Testimonial-Chop.svg" loading="lazy" alt="n2xpress - Send money across borders, the easy way." class="image-2">
    <div class="section-header-text instructions"><strong>How N2Xpress helps in three ways?</strong></div>
  </div>
  <div class="n2xpress-help">
    <div class="w-container">
      <div class="benefits-body n2xpress-help-body">
        <div class="cxy-benefit-box">
          <div class="cxy-benefit-header">
            <div class="pink"><strong>Users</strong></div>
          </div>
          <div class="benefit-body">
            <div class="benefit-body-text">It provides options to remittance users to send money to Nigeria and meet the demands of their loved ones, friends, and family in the best way possible.</div>
          </div>
        </div>
        <div class="cxy-benefit-box">
          <div class="cxy-benefit-header">
            <div class="pink"><strong class="yellow">Businesses</strong></div>
          </div>
          <div class="benefit-body">
            <div class="benefit-body-text">Advancement in technology brings lots of benefits, it makes it easier to pay businesses and do global transfer to meet the demands fast. You can now meet your business needs and transfer globally using N2Xpress.</div>
          </div>
        </div>
        <div class="cxy-benefit-box">
          <div class="cxy-benefit-header">
            <div class="pink"><strong class="purple">Partners </strong></div>
          </div>
          <div class="benefit-body">
            <div class="benefit-body-text">Reach a highly valuable remittance audience easily through marketplaces created by money transfer providers like N2Xpress.</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="currencies-section">
    <div class="currency-container w-container">
        <div class="currency-header"><img src="assets/images/Testimonial-Chop.svg" loading="lazy" alt="n2xpress - Send money across borders, the easy way." class="image-2">
            <div class="section-header-text">Currencies</div>
        </div>
        <div class="currency-intro">
          <div class="text-block-8">We specialise in sending money from The United States to the most popular markets including Ghana, Kenya and India with more to come.<br></div>
        </div>
        <div class="currency-flag-holder usa-money-flags text-center">
            <div class="currency-flag lower-flag"><img  src="assets/images/india-flag.PNG" loading="lazy" width="70px" height="50px" alt="" class="flag">
                <div class="currency-code text-center mt-2">Indian Rupee</div>
                <small>INR</small>
            </div>
            <div class="currency-flag"><img   src="assets/images/kenya-flag.PNG" loading="lazy" width="70px" height="50px" class="flag">
                <div class="currency-code mt-2">Kenyan Shilling</div>
                <small>KES</small>
            </div>
            <div class="currency-flag lower-flag"><img   src="assets/images/ghana-flag.png" loading="lazy" width="70px" height="50px" alt="" class="flag">
                <div class="currency-code mt-2">Ghanaian Cedi</div>
                <small>GHS</small>
            </div>
        </div>
    </div>
</div>
<div class="send-money-section">
    <div class="instruction-header send-money-heading-section"><img src="assets/images/Testimonial-Chop.svg" loading="lazy" alt="n2xpress - Send money across borders, the easy way." class="image-2">
      <div class="section-header-text instructions"><strong>Send money to Nigeria</strong></div>
    </div>
    <div class="box-wrapper">
      <p class="send-money-paragraph-section">Money transfers to Nigeria is not new. Remittances have existed for a long time but with technological advancement and mobile phones, the experience has become a lot faster and affordable. <br>‍<br>According to World Bank data, Nigeria is in the list of the largest receivers of remittances. In 2018, a total of US$23.63 billion migrant remittance flow to Nigeria. Nigeria&#x27;s remittance inflows was also 7.4 timeslarger than the net official developmentassistance (foreign aid) received in 2017. From this you can estimate what is remittance growth and it will continue to be on this track in coming years. <br><br>N2Xpress has simplified the transfer process through instant online money transfers. You can now send money from The United States to Nigeria using a variety of methods including card, cheques, bank transfers and mobile airtime top ups.<br><br>The choice is up to you, but we’ll make sure it’s fast, convenient and secure. We always show you the USD to NGN exchange rates and low fees upfront, without hidden charges. Ever.</p>
    </div>
  </div>
<div class="faq-section">
    <div class="box-wrapper">
        <div class="faq-heading">Frequently Asked Questions</div>
        <div class="card border-0">
            <div class="card-header border-0 bg-transparent" id="headingTwo">
                <h3 class="heading-15 d-flex justify-content-between align-items-center cursor-pointer" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                    What is overseas money transfer? <i class="fas fa-chevron-down ml-auto"></i>
                </h3>
            </div>
            <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
                <p class="paragraph-2 px-2">An overseas money transfer is sending money abroad from the resident country to any overseas country. You can send money to recipients to meet your urgent business or personal needs. It serves various purposes like medical treatment abroad, supporting close relatives, private visits, paying bills, etc. A fast way to transfer money to your loved ones at affordable rates when needed most is using N2Xpress.</p>
            </div>
        </div>
        
        <div class="card border-0">
            <div class="card-header border-0 bg-transparent" id="headingThree">
                <h3 class="heading-15 d-flex justify-content-between align-items-center cursor-pointer" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                    How does N2Xpress work?<i class="fas fa-chevron-down ml-auto"></i>
                </h3>
            </div>
            <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordionExample">
                <p class="paragraph-2 px-2">N2Xpress is a digital remittance platform which works on the concept of “Save More &amp; Do More”. We are making it easier to send money globally and provide a world class service that is hassle free. We save remitters money by providing competitive exchange rate and transfer fees.</p>
            </div>
        </div>
        
        <div class="card border-0">
            <div class="card-header border-0 bg-transparent" id="headingFour">
                <h3 class="heading-15 d-flex justify-content-between align-items-center cursor-pointer" data-toggle="collapse" data-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                    Is it safe to send money online through N2Xpress? <i class="fas fa-chevron-down ml-auto"></i>
                </h3>
            </div>
            <div id="collapseFour" class="collapse" aria-labelledby="headingFour" data-parent="#accordionExample">
                <p class="paragraph-2 px-2">At N2Xpress due care is taken and precaution is exercised to maintain high-level security. We use a compliance process and highest security while transferring. It is important to ensure safety first and to keep information of both the remitter and recipient safe and secure. Check data entered twice and select the transfer option. Stay safe and alert of fraud - in case you receive anything irrelevant related to our service, mail us with details and we will look into it.</p>
            </div>
        </div>
        
        <div class="card border-0">
            <div class="card-header border-0 bg-transparent" id="headingFive">
                <h3 class="heading-15 d-flex justify-content-between align-items-center cursor-pointer" data-toggle="collapse" data-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                    What is N2Xpress and how to transfer money to Nigeria?<i class="fas fa-chevron-down ml-auto"></i>
                </h3>
            </div>
            <div id="collapseFive" class="collapse" aria-labelledby="headingFive" data-parent="#accordionExample">
                <p class="paragraph-2">N2Xpress is an online money transfer platform which enables you to send money from The United States to anywhere in Nigeria. All you have to do is register on <a routerLink="/">www.n2xpress.com</a> and create a free account. Submit simple verification documents and remit online in just a few taps.</p>
            </div>
        </div>
        
        <div class="card border-0">
            <div class="card-header border-0 bg-transparent" id="headingSix">
                <h3 class="heading-15 d-flex justify-content-between align-items-center cursor-pointer" data-toggle="collapse" data-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
                    How much does it cost to transfer money to Nigeria?<i class="fas fa-chevron-down ml-auto"></i>
                </h3>
            </div>
            <div id="collapseSix" class="collapse" aria-labelledby="headingSix" data-parent="#accordionExample">
                <p class="paragraph-2">Send money in USD to NGN with a flat fee on different amounts and transactions. N2Xpress shows total cost upfront and so there are no hidden charges or cost. Before transacting, check our minimum transfer fee on every transaction. Maximum limit per transaction is $10000.<br>Transfer fee structure<br>‍<br>$1      -$1000      - $5<br>$1001-$1500      - $10<br>$1501-$10000   - $15<br>‍<br></p>
            </div>
        </div>
        
        <div class="card border-0">
            <div class="card-header border-0 bg-transparent" id="headingSeven">
                <h3 class="heading-15 d-flex justify-content-between align-items-center cursor-pointer" data-toggle="collapse" data-target="#collapseSeven" aria-expanded="false" aria-controls="collapseSeven">
                    Best online platform to transfer money from The United States to Nigeria?<i class="fas fa-chevron-down ml-auto"></i>
                </h3>
            </div>
            <div id="collapseSeven" class="collapse" aria-labelledby="headingSeven" data-parent="#accordionExample">
                <p class="paragraph-2">When you want to transfer money from The United States to Nigeria, then focus on these key points.<br></p>
                <ul role="list">
                  <li>Good exchange rate</li>
                  <li>Low transfer fee</li>
                  <li>Fastest money transfer</li>
                  <li>Multiple options for transfer</li>
                  <li>Secure and guaranteed money transfer<br></li>
                </ul>
                <p class="paragraph-2">When you are looking to transfer United States Dollar (USD) to Nigerian Naira (NGN) you should keep a few things in mind. There are a number of options available but it’s your call to choose the best online remittance platform with the best currency converter exchange rates.<br></p>
            </div>
        </div>
        
        <div class="card border-0">
            <div class="card-header border-0 bg-transparent" id="headingEight">
                <h3 class="heading-15 d-flex justify-content-between align-items-center cursor-pointer" data-toggle="collapse" data-target="#collapseEight" aria-expanded="false" aria-controls="collapseEight">
                    Best rate to transfer USD and NGN?<i class="fas fa-chevron-down ml-auto"></i>
                </h3>
            </div>
            <div id="collapseEight" class="collapse" aria-labelledby="headingEight" data-parent="#accordionExample">
                <p class="paragraph-2">For somebody to transfer to Nigeria, N2Xpress offers the best deal to transfer United States dollar to Nigerian Naira. USD-NGN conversion rate. Check out the currency converter at the top of the page to find out today’s rate.<br></p>
            </div>
        </div>
        
        <div class="card border-0">
            <div class="card-header border-0 bg-transparent" id="headingNine">
                <h3 class="heading-15 d-flex justify-content-between align-items-center cursor-pointer" data-toggle="collapse" data-target="#collapseNine" aria-expanded="false" aria-controls="collapseNine">
                    How can I wire money transfer from The United States to Nigeria?<i class="fas fa-chevron-down ml-auto"></i>
                </h3>
            </div>
            <div id="collapseNine" class="collapse" aria-labelledby="headingNine" data-parent="#accordionExample">
                <p class="paragraph-2">Stay connected with your loved ones with N2Xpress by wiring money transfer from The United States to Nigeria using a debit card, credit card or airtime top up.<br></p>
            </div>
        </div>
        
        <div class="card border-0">
            <div class="card-header border-0 bg-transparent" id="headingTen">
                <h3 class="heading-15 d-flex justify-content-between align-items-center cursor-pointer" data-toggle="collapse" data-target="#collapseTen" aria-expanded="false" aria-controls="collapseTen">
                    How long does it take to send money to Nigeria?<i class="fas fa-chevron-down ml-auto"></i>
                </h3>
            </div>
            <div id="collapseTen" class="collapse" aria-labelledby="headingTen" data-parent="#accordionExample">
                <p class="paragraph-2">It mostly depends on:<br></p>
                <ul role="list">
                  <li>Public holidays or weekends</li>
                  <li>Countries you send from</li>
                  <li>Security checks</li>
                  <li>Payment Methods</li>
                </ul>
                <p class="paragraph-2">N2Xpress is the cheapest and fastest way to send money to Nigeria from the United States. <a routerLink="/register">Sign Up</a><br><br></p>
            </div>
        </div>
        
        <div class="card border-0">
            <div class="card-header border-0 bg-transparent" id="headingEleven">
                <h3 class="heading-15 d-flex justify-content-between align-items-center cursor-pointer" data-toggle="collapse" data-target="#collapseEleven" aria-expanded="false" aria-controls="collapseEleven">
                    Which is the fastest and cheapest mode of money transfer to Nigeria from The United States?<i class="fas fa-chevron-down ml-auto"></i>
                </h3>
            </div>
            <div id="collapseEleven" class="collapse" aria-labelledby="headingEleven" data-parent="#accordionExample">
                <p class="paragraph-2">When it comes to international money transfer, you always look for the fastest and most convenient options. N2Xpress meets both the criteria of being the fastest and the cheapest mode of money transfer from The United States to Nigeria. The banks are not the best way to transfer money as they are most expensive in terms of fees and exchange rates.<br></p>
            </div>
        </div>
    </div>
</div>

<div class="w-embed w-iframe">
    <!--  Google Tag Manager (noscript)  -->
    <noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-NT3DRQ6" height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>
    <!--  End Google Tag Manager (noscript)  -->
    <noscript><img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=126238879075083&ev=PageView&noscript=1"></noscript>
</div>

<style>
    .accordion-item-trigger .accordion-icon{
        transition: all 0.2s ease-out; 
    }
    .accordion-item-trigger + .accordion-item-content{
        transition: all 0.2s ease-out; 
    }
</style>

<app-home-footer></app-home-footer>